import { render } from "./ScrollTop.vue?vue&type=template&id=d60c0cca"
import script from "./ScrollTop.vue?vue&type=script&lang=ts"
export * from "./ScrollTop.vue?vue&type=script&lang=ts"
script.render = render

export default script